export const ENTITY_PHASE_LIST_LOADING_ITEMS_COUNT = 3
